<template>
    <Vue100vh>
        <GMap class="col map"
              map-type-id="terrain"
              ref="main_map"
              style="height: 100%; width: 100%"
              @center_changed="onCenterChanged"
              :center="centerMap"
              :options="{
                   zoomControl: false,
                   mapTypeControl: false,
                   scaleControl: false,
                   streetViewControl: false,
                   rotateControl: false,
                   fullscreenControl: false,
                   disableDefaultUi: false,
                   zoom: zoomMap
              }">
        </GMap>
        <div v-if="!!(hasCoordinates)" class="markerFixed" style="pointer-events: none;">
            <img class="marker" alt="" src="../../assets/marker.png"/>
        </div>
    </Vue100vh>
</template>

<script>
	import { SET_COORDINATES, SET_MAP } from '../../store/mutations';
	import { Map } from 'vue2-google-maps';
    import { mapGetters } from 'vuex';

	export default {
		name: 'Map',
		data() {
			return {
				editable: true,
			};
		},
		components: {
			GMap: Map,
        },

        computed: {
            ...mapGetters({ hasCoordinates: 'ProspectVuex/prospect_has_coordinates', centerMap: 'center', zoomMap: 'zoomMap', prospect: 'ProspectVuex/prospect' })
        },
       
		mounted() {
			this.$refs.main_map.$mapPromise.then( map => {    
				this.$store.commit(SET_MAP, map);
			});
		},
		methods: {
			onCenterChanged(center) {
                if (!this.prospect) console.log('SEM PROSPECT')
				this.$store.commit(`ProspectVuex/${SET_COORDINATES}`, {
					coordinates: {
						lat: center.lat(),
						lng: center.lng(),
					},
				});
			},
		},
	};
</script>

<style scoped>
    .markerFixed {
        left: 50%;
        margin-left: -24px;
        margin-top: -48px;
        position: absolute;
        top: 50%;
    }

    .marker {
        height: 48px;
        width: 48px;
    }
</style>
